export const ACCOUNT_STATUS = {
  ACTIVE: 1,
  BLOCKED: 2,
};

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
};

export const UNLIMITED = 1;

export const BOOK_STATUS = {
  NEW: 1,
  LIKE_NEW: 2,
  GOOD: 3,
  USED: 4,
  WELL_USED: 5,
  DAMAGED: 6,
  UNUSABLE: 7,
};

export const LOAN_STATUS = {
  BORROWING: 1,
  PAID: 2,
  LOST: 3,
};
export const PENALTY_TICKET_STATUS = {
  UNPAID: 1,
  PAID: 2,
};
export const ACTIVITY_TYPE = {
  CREATED: 1,
  UPDATED: 2,
  DELETED: 3,
  GIVE_BOOK_BACK: 4,
};
export const USER_TYPE = {
  ALL: 3,
  SYSTEM_USER: 1,
  READER: 2,
};

export const TABLE_NAME = {
  BOOK: 'Ấn phẩm',
  BOOK_LOST: 'Mất ấn phẩm',
  BOOK_REQUEST: 'Yêu cầu bổ sung ấn phẩm',
  POSITION: 'Kệ ấn phẩm',
  CATEGORY: 'Danh mục ấn phẩm',
  LOAN_RECEIPT: 'Mượn/Trả ấn phẩm',
  FINE_POLICY: 'Phí phạt',
  FINE_POLICY_WITH_BOOK: 'Chi tiết phạt',
  PENALTY_TICKET: 'Phiếu phạt quá hạn',
  SETTING: 'Cài đặt',
  ACCOUNT: 'Tài khoản',
  USER: 'Người dùng',
  CARD_OPENING_FEE: 'Phí mở thẻ',
  BOOKING_BOOK_FORM: 'Đăng ký mượn sách',
  FIELD: 'Lĩnh vực',
  BOOK_STATUS: 'Trạng thái ấn phẩm',
  PUBLISHER: 'Nhà xuất bản',
  READER_GROUP: 'Nhóm bạn đọc',
  SCHOOL_YEAR: 'Niên khóa',
  CLASS: 'Lớp học',
  LANGUAGE: 'Ngôn ngữ',
};

export const QUERY_ONE_TYPE = {
  ID: 1,
  CODE: 2,
};
export const TYPE_LOAN_FEE = {
  FIXED_PRICE: 1,
  BOOK_COVER_PERCENTAGE: 2,
};
